import React from 'react';
import { render } from 'react-dom';

import ErrorBoundary from './components/ErrorBoundary';
import Root from './containers/Root';

const root = document.getElementById('app');

render(
  <ErrorBoundary>
    <Root />
  </ErrorBoundary>,
  root,
);
